export default {
  title: "Post mint Roadmap",
  text: "Designed to build a large and engaged community of Shamanzs loverzs (aka The Shamagang).",
};
